import type { SxProps, Theme } from '@mui/material'

const snackbarSx: SxProps<Theme> = {
  zIndex: 9999,
}

const alertSx: SxProps<Theme> = {
  width: '100%',
  fontSize: '0.8125rem',
  alignItems: 'center',
  '& .MuiAlert-icon': {
    fontSize: '1.1rem',
    marginRight: 1,
    padding: 0,
    alignItems: 'center',
  },
  '& .MuiAlert-message': {
    padding: '6px 0',
    lineHeight: 1.4,
  },
  '& .MuiAlert-action': {
    padding: '0 0 0 8px',
    alignItems: 'center',
  },
}

export { alertSx, snackbarSx }
